import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { clientSide } from '../../config_react.js'
const { redirectToStorage } = clientSide[0]

export default class cloudStorage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedCloudStorage: '',
            authorizationLink: '',
        }
    }

    componentDidMount() {
        fetch(`${redirectToStorage}/getstorageurl?driveTypeId=${1}`, {
            method: 'GET',
            headers: {
                Cache: 'no-cache',
            },
            credentials: 'include',
        })
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText)
                }
                return response
            })
            .then(response => response.json())
            .then(authLink => {
                console.log(`return: /getstorageurl`)
                console.log(authLink)
                this.setState({
                    authorizationLink: authLink.url,
                })
            })
            .catch(err => {
                throw Error(err.message).stack
            })
    }

    render() {
        let translate = this.props.translate

        return (
            <div className="cloudStorage">
                <div className="cloudStorage_info">
                    <div className="cloudStorage_info_icon">
                        <FontAwesomeIcon icon={['fas', 'info']} />
                    </div>
                    <div className="cloudStorage_info_message">
                        <p>{translate['To continue working']}</p>
                        <span>
                            {translate['connect to your cloud storage']}
                        </span>
                    </div>
                    <div className="cloudStorage_info_cloudList">
                        <div className="selectedStore">
                            <FontAwesomeIcon icon={['fab', 'google-drive']} />
                        </div>
                    </div>
                </div>
                <div className="cloudStorage_authorization">
                    <div className="cloudStorage_authorization_cloudName">
                        Google Drive
                    </div>
                    <a href={this.state.authorizationLink}>
                        <div className="cloudStorage_authorization_button">
                            {translate['connect']}
                        </div>
                    </a>
                </div>
            </div>
        )
    }
}
